import { render, staticRenderFns } from "./AboutLookin.vue?vue&type=template&id=0c6103bc&"
import script from "./AboutLookin.vue?vue&type=script&lang=js&"
export * from "./AboutLookin.vue?vue&type=script&lang=js&"
import style0 from "./AboutLookin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports